import { getCachedInitialProps } from '@/components/helpers/fetchInitialProps';
import { TmModelHomeDetail } from './tm-model-home-detail';
import { ITmModelHomeDetailCSProps } from './tm-model-home-detail.types';
import { fetchModelHomeDetailData } from './utils';

export const TmModelHomeDetailCMS = async ({
  block,
}: {
  block: ITmModelHomeDetailCSProps;
}) => {
  const { studioData } = await getCachedInitialProps();
  const {
    studio,
    currentModelData,
    additionalModelData,
    floorPlans,
    additionalModelHomesLabel,
  } = await fetchModelHomeDetailData(block, studioData);
  return (
    <TmModelHomeDetail
      block={block}
      studio={studio}
      currentModelData={currentModelData}
      additionalModelData={additionalModelData}
      floorPlans={floorPlans}
      additionalModelHomesLabel={additionalModelHomesLabel}
    />
  );
};
